import { Table } from "antd";

const Table3 = () => {
    const dataSource = [
        {
            key: 1,
            stt: 1,
            bank: 'ACB',
            month03: '2.65%',
            month06: '4.75%',
            month09: '5.85%',
            month12: '7.65%',
        },
        {
            key: 2,
            stt: 2,
            bank: 'BIDV',
            month03: '2.00%',
            month06: '3.65%',
            month09: '4.65%',
            month12: '5.60%',
            month15: '7.45%',
            month18: '8.45%',
            month21: '10.45%',
            month24: '11.45%',
        },
        {
            key: 3,
            stt: 3,
            bank: 'Eximbank',
            month03: '2.10%',
            month06: '3.63%',
            month09: '5.05%',
            month12: '6.65%',
        },
        {
            key: 4,
            stt: 4,
            bank: 'HDBank',
            month03: '3.35%',
            month06: '4.85%',
            month09: '6.15%',
            month12: '7.75%',
        },
        {
            key: 5,
            stt: 5,
            bank: 'HSBC',
            month03: '2.75%',
            month06: '4.55%',
            month09: '6.10%',
            month12: '7.65%',
        },
        {
            key: 6,
            stt: 6,
            bank: 'Kiên Long Bank',
            month03: '2.00%',
            month06: '3.55%',
            month09: '4.60%',
            month12: '6.60%',
        },
        {
            key: 7,
            stt: 7,
            bank: 'MSB',
            month03: '2.60%',
            month06: '4.60%',
            month09: '6.00%',
            month12: '7.60%',
        },
        {
            key: 8,
            stt: 8,
            bank: 'Nam A Bank',
            month03: '2.35%',
            month06: '4.12%',
            month09: '4.75%',
            month12: '5.55%',
        },
        {
            key: 9,
            stt: 9,
            bank: 'OCB',
            month03: '2.95%',
            month06: '4.15%',
            month09: '5.55%',
            month12: '7.00%',
        },
        {
            key: 10,
            stt: 10,
            bank: 'SCB',
            month03: '2.65%',
            month06: '4.55%',
            month09: '6.10%',
            month12: '7.60%',
        },
        {
            key: 11,
            stt: 11,
            bank: 'Seabank',
            month03: '2.85%',
            month06: '4.15%',
            month09: '5.25%',
            month12: '6.45%',
        },
        {
            key: 12,
            stt: 12,
            bank: 'SHB',
            month03: '2.35%',
            month06: '3.65%',
            month09: '4.70%',
            month12: '5.65%',
        },
        {
            key: 13,
            stt: 13,
            bank: 'Shinhan&ANZ',
            month06: '4.25%',
            month09: '4.65%',
            month12: '5.80%',
        },
        {
            key: 14,
            stt: 14,
            bank: 'Standard Chartered',
            month03: '2.45%',
            month06: '4.35%',
            month09: '5.65%',
            month12: '7.00%',
        },
        {
            key: 15,
            stt: 15,
            bank: 'Techcombank',
            month03: '3.65%',
            month06: '6.65%',
            month09: '8.55%',
            month12: '10.50%',
        },
        {
            key: 16,
            stt: 16,
            bank: 'TPB',
            month03: '2.55%',
            month06: '4.55%',
            month09: '6.15%',
            month12: '7.75%',
        },
        {
            key: 17,
            stt: 17,
            bank: 'VIB',
            month03: '3.45%',
            month06: '4.95%',
            month09: '6.20%',
            month12: '7.55%',
        },
        {
            key: 18,
            stt: 18,
            bank: 'Viet Capital Bank',
            month03: '2.00%',
            month06: '3.65%',
            month09: '5.15%',
            month12: '6.35%',
        },
        {
            key: 19,
            stt: 19,
            bank: 'Vietcombank',
            month03: '2.85%',
            month06: '3.65%',
            month09: '4.60%',
            month12: '6.75%',
        },
        {
            key: 20,
            stt: 20,
            bank: 'Vietinbank',
            month03: '1.95%',
            month06: '3.75%',
            month09: '5.12%',
            month12: '6.65%',
        },
        {
            key: 21,
            stt: 21,
            bank: 'VPBank',
            month03: '2.63%',
            month06: '4.12%',
            month09: '7.55%',
            month12: '8.45%',
        },
        {
            key: 22,
            stt: 22,
            bank: 'PVcomBank',
            month03: '2.10%',
            month06: '3.45%',
            month09: '4.55%',
            month12: '5.55%',
        },
    ];

    const columns = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 60,
            align: 'center',
        },
        {
            title: 'Ngân hàng',
            dataIndex: 'bank',
            key: 'bank',
            width: 140,
            align: 'center',
        },
        {
            title: 'Phí tiêu chuẩn',
            children: [
                {
                    title: (
                        <>
                            Kỳ hạn
                            <br />
                            03 tháng
                        </>
                    ),
                    dataIndex: 'month03',
                    key: 'month03',
                    width: 70,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Kỳ hạn
                            <br />
                            06 tháng
                        </>
                    ),
                    dataIndex: 'month06',
                    key: 'month06',
                    width: 70,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Kỳ hạn
                            <br />
                            09 tháng
                        </>
                    ),
                    dataIndex: 'month09',
                    key: 'month09',
                    width: 70,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Kỳ hạn
                            <br />
                            12 tháng
                        </>
                    ),
                    dataIndex: 'month12',
                    key: 'month12',
                    width: 70,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Kỳ hạn
                            <br />
                            15 tháng
                        </>
                    ),
                    dataIndex: 'month15',
                    key: 'month15',
                    width: 70,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Kỳ hạn
                            <br />
                            18 tháng
                        </>
                    ),
                    dataIndex: 'month18',
                    key: 'month18',
                    width: 70,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Kỳ hạn
                            <br />
                            21 tháng
                        </>
                    ),
                    dataIndex: 'month21',
                    key: 'month21',
                    width: 70,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Kỳ hạn
                            <br />
                            24 tháng
                        </>
                    ),
                    dataIndex: 'month24',
                    key: 'month24',
                    width: 70,
                    align: 'center',
                },
            ],
        },
    ];
    return (
        <div className="mt-5">
            <h2 className="fw-bold fs-4 mb-3 text-center">BẢNG 3: BIỂU PHÍ TRẢ GÓP HPAY THEO SẢN LƯỢNG</h2>
            <div>
                <Table
                    bordered
                    pagination={false}
                    dataSource={dataSource}
                    columns={columns}
                    rowKey="key"
                />
            </div>
        </div>

    );
};
export default Table3;